import styled from 'styled-components';

export const StyledApp = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const StyledContent = styled.div`
  height: calc(100% - 72px);
  display: flex;
  flex-direction: row;
`;
